import { render } from "./AssTeacherHome.vue?vue&type=template&id=650ce191&scoped=true"
import script from "./AssTeacherHome.vue?vue&type=script&lang=js"
export * from "./AssTeacherHome.vue?vue&type=script&lang=js"

import "./AssTeacherHome.vue?vue&type=style&index=0&id=650ce191&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650ce191"]])

export default __exports__